@use "../../sass/global/global" as *;

$duration: 200ms;
$paddingRight: 11px;

:host {
    box-sizing: border-box;
    margin: 0 0 0 auto;
    display: block;
    position: sticky;
    right: 0;
    height: 0;
    width: 300px;
    top: 40%;
    text-align: right;
    z-index: 1;
    @include font(regular);

    @media (max-width: 1024px) {
        display: none;
    }
}

:host([is-sticky]) {
    .headline,
    .chapter {
        color: transparent;
    }

    .inner:not(:hover) {
        --ux-button-primary-bg-color: #{$color-blue-5};
        --ux-button-primary-text-color: #{$color-blue-2};
    }

    .inner:hover {
        background-color: #fff;

        .headline {
            color: $color-black-1;
        }

        .chapter {
            color: $color-blue-3;
        }
    }
}

.inner {
    padding: 40px;
    background-color: transparent;
    transition: background-color $duration ease-in-out;
}

.headline {
    @include font(bold);
    color: $color-black-1;
    font-size: 13px;
    text-transform: uppercase;
    margin: 0 $paddingRight 30px 0;
    transition: color $duration ease-in-out;
}

.chapter {
    color: $color-blue-3;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: color $duration ease-in-out;
    padding: 5px calc(32px + #{$paddingRight}) 5px 10px;
    position: relative;

    &::after {
        display: block;
        content: "";
        height: 12px;
        width: 12px;
        background: $color-blue-5;
        transition: background $duration ease-in-out;
        position: absolute;
        top: 50%;
        right: 11px;
        transform: translateY(-50%);
    }

    &--active {
        color: $color-blue-1;

        &::after {
            background: $color-blue-1;
        }
    }

    &:hover {
        color: $color-blue-1 !important;
    }
}

.contact-button {
    margin-top: 20px;
}
